import Button from '@/components/Button';
import Card from '@/components/Card';
import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import { Body } from '@/components/Typography';

type Props = {
  hideModal: () => void;
  onConfirm: () => void;
};

const RemoveJobFromOrderModal = ({ hideModal, onConfirm }: Props) => {
  return (
    <Modal
      disableClickout
      size="xs"
      title="Remove shift"
      onRequestClose={hideModal}
    >
      <Card.Section>
        <Stack vertical gap={24}>
          <Body>Are you sure you want to remove the shift from the order?</Body>
          <Stack justify="end">
            <Button
              a11yLabel="Close"
              appearance="outline"
              label="Close"
              onClick={hideModal}
            />
            <Button
              a11yLabel="Cancel shift"
              appearance="primary"
              label="Remove shift"
              onClick={onConfirm}
            />
          </Stack>
        </Stack>
      </Card.Section>
    </Modal>
  );
};

export default RemoveJobFromOrderModal;
